<template>
<div v-if="who.id != user.id">
	<a v-if="who.friendship == null" href="#" class="btn btn-primary" @click.prevent="addFriend()">
        Als {{ friend }} hinzufügen
    </a>

    <a v-if="who.friendship == 'pending'" href="#" class="btn btn-secondary" @click.prevent="unfriend()">
        Anfrage zurückziehen
    </a>

    <template v-if="who.friendship == 'requested'">
        <a href="#" class="btn btn-primary btn-left" @click.prevent="acceptFriend()">
            Freundschaft akzeptieren
        </a>
        <a href="#" class="btn btn-secondary btn-right" @click.prevent="unfriend()">
            Ablehnen
        </a>
    </template>

    <a v-if="who.friendship == 'friends'" href="#" class="btn btn-secondary" @click.prevent="unfriend()">
        Entfreunden
    </a>
</div>
</template>

<script>
import base from 'base.vue'

export default {
    mixins: [ base ],
	props: [ 'who' ],
	computed: {
        friend () {
            if (this.who.sex == 'male') {
                return 'Freund'
            } else if (this.who.sex == 'female') {
                return 'Freundin'
            } else {
                return 'Freund/in'
            }
        }
	},
	methods: {
		// Send friend request
		addFriend () {
            const that = this

            this.$api.post(`user/${this.who.id}/request-friend`)
            .then(response => {
                that.who.friendship = 'pending'
            })
        },
        // Accept incoming friend request
        acceptFriend () {
            const that = this
            
            this.$api.post(`user/${this.who.id}/accept-friend`)
            .then(response => {
                that.who.friendship = 'friends'
            })
        },
        // Retract friendship request or stop existing friendship
        unfriend () {
            const that = this
            this.$api.post(`user/${this.who.id}/unfriend`)
            .then(response => {
                that.who.friendship = null
            })
        }
	}
}
</script>


// WEBPACK FOOTER //
// friendship-button.vue?249377fe